import { render, staticRenderFns } from "./AdminProductsSubMenusLinks.vue?vue&type=template&id=50b16e15"
import script from "./AdminProductsSubMenusLinks.vue?vue&type=script&lang=js"
export * from "./AdminProductsSubMenusLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50b16e15')) {
      api.createRecord('50b16e15', component.options)
    } else {
      api.reload('50b16e15', component.options)
    }
    module.hot.accept("./AdminProductsSubMenusLinks.vue?vue&type=template&id=50b16e15", function () {
      api.rerender('50b16e15', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/menu/sub-menus/products/AdminProductsSubMenusLinks.vue"
export default component.exports